import script from "./CompanyTableActions.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyTableActions.vue?vue&type=script&setup=true&lang=js"

import "./CompanyTableActions.vue?vue&type=style&index=0&id=028b145e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-028b145e"]])

export default __exports__